module.exports = __webpack_public_path__ + "static/media/discountEdit.31938572.svg";